@if (visible) {
<span class="flex items-center w-full h-full">
    <button mat-icon-button (click)="onClick()" [disabled]="isDisabled" [matTooltip]="params.tooltip"><mat-icon [matBadge]="params.badge">{{ icon }}</mat-icon></button>
</span>
}
